export class SBError extends Error {
    constructor(message) {
        super(message);
    }
}
export class InvalidLicenseError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'InvalidLicense';
    }
}
export class NullPointerError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'NullPointer';
    }
}
export class InvalidArgumentError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'InvalidArgument';
    }
}
export class InvalidImageRefError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'InvalidImageRef';
    }
}
export class ComponentUnavailableError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'ComponentUnavailable';
    }
}
export class IllegalStateError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'IllegalState';
    }
}
export class IOError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'IOError';
    }
}
export class InvalidDataError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'InvalidData';
    }
}
export class OutOfMemoryError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'OutOfMemory';
    }
}
export class TimeoutError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'Timeout';
    }
}
export class UnknownError extends SBError {
    constructor(message) {
        super(message);
        this.type = 'Unknown';
    }
}
export class ProcessError extends SBError {
    constructor(message, code) {
        super(message);
        this.type = 'ProcessError';
        this.code = code;
    }
}
/**
 * @internal
 * @hidden
 */
export function createSBError(err) {
    const code = Number(err.code);
    const message = err.message || err.errorMessage || 'An unknown error occurred';
    switch (code) {
        case 1:
            return new UnknownError(message);
        case 2:
            return new InvalidLicenseError(message);
        case 3:
            return new NullPointerError(message);
        case 4:
            return new InvalidArgumentError(message);
        case 5:
            return new InvalidImageRefError(message);
        case 6:
            return new ComponentUnavailableError(message);
        case 7:
            return new IllegalStateError(message);
        case 8:
            return new IOError(message);
        case 9:
            return new InvalidDataError(message);
        case 11:
            return new OutOfMemoryError(message);
        case 12:
            return new TimeoutError(message);
        default: {
            if (code >= 100) {
                return new ProcessError(message, code);
            }
            return new UnknownError(message);
        }
    }
}
//# sourceMappingURL=errors.js.map